import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { openProductModal } from "../../../redux/features/productModalSlice";
import Search from "../../../common/Search";

import {
  SubCategoryList,
  DeleteSubCategory,
  ChangeStatusSubCategory,
} from "../../../redux/services/subCategoriesService/subCategories.Services";
import Swal from "sweetalert2";
import Pagination from "../../../common/Pagination";
function SubCategoriesList() {
  const dispatch = useDispatch();
  const [subCategories, setSubCategories] = useState([]);
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const refreshData = useSelector((state) => state.productModal.refreshData);
  const [loading, setLoading] = useState(true);

  const fetchSubCategories = async () => {
    try {

      setLoading(true);

      const payload = {
        page,
        search,
        status,
      };

      const res = await SubCategoryList(payload);
      setSubCategories(res?.data?.data || []);
      setLastPage(res?.data?.last_page || 1);
      setTotalRecords(res?.data?.total || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubCategories();
  }, [page, search, status, refreshData]);
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };


  return (
    <div >
      <div className="d-md-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="page-header">
          <div>
            <h3 className="page-title"> Sub Categories List</h3>
            <nav className="page-breadcrumb">
              <Link to="/">Home</Link>
              <span className="mx-2">/</span>
              <span>Sub Categories </span>
            </nav>
          </div>
        </div>
        <button
          className="add-btn"
          onClick={() =>
            dispatch(
              openProductModal({
                type: "create-subcategory",
                title: "Create SubCategory",
                data: {
                  refreshData: fetchSubCategories,
                },
              }),
            )
          }
        >
          + Add Sub Category
        </button>
      </div>
      <div className="main_page">
        {(totalRecords > 0 || search.trim() !== "") && (
          <div className="d-flex justify-content-end align-items-center mx-2">
            <Search
              search={search}
              placeholder="Search Sub Category..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>SubCategory Name</th>
                  <th> Category Name</th>
                  <th>Change Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {subCategories.length > 0 ? (
                  subCategories.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1 + (page - 1) * limit}</td>
                      <td>{item?.name}</td>
                      <td>{item?.category_details?.name}</td>

                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item.id}`}
                            className="city-status-input"
                            checked={item.status === 1}
                            onChange={() =>
                              dispatch(
                                openProductModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    status: item.status ? "Active" : "Inactive",
                                    statusFunction: ChangeStatusSubCategory,
                                    onSuccess: fetchSubCategories,
                                  },
                                })
                              )
                            }
                          />

                          <label
                            htmlFor={`status-${item.id}`}
                            className="city-status-label">
                            <span className="city-status-ball"></span>
                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </div>
                      </td>

                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "view-subcategory",
                                  title: "View SubCategory",
                                  data: item,
                                })
                              )
                            }
                          >
                            <FaEye />
                          </button>

                          {/* Edit */}
                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "edit-subcategory",
                                  title: "Edit SubCategory",
                                  data: {
                                    ...item,
                                    refreshData: fetchSubCategories,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button>

                          {/* Delete */}
                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-subcategory",
                                  title: "Delete SubCategory",
                                  data: {
                                    id: item.id,
                                    deleteFunction: DeleteSubCategory,
                                    refreshData: fetchSubCategories,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>

  );
}

export default SubCategoriesList;
